import React from 'react'
import AboutHero from '../about/about-hero'
import AboutWhat from '../about/about-what2'
// import { useGetTacQuery } from 'src/store/Reducer/settings'

const TermsOfConditionsView = () => {
    // let { data } = useGetTacQuery({ language: currentLang.value });
    return (
        <div>
            <AboutHero data={{ title: "Our", list: ["Terms and Conditions"] }} />
            <AboutWhat data={{ title: "", content: data?.data?.text, image: `${process.env.PUBLIC_URL}/assets/terms.jpg` }} />
        </div>
    )
}

export default TermsOfConditionsView


const data = {
    "data": { "text": "<h2>Terms and Conditions</h2>\n<p>Welcome to [Your Company Name]! These terms and conditions outline the rules and regulations for the use of [Your Company Name]'s Website, located at [Your Website URL].</p>\n<p>By accessing this website we assume you accept these terms and conditions. Do not continue to use [Your Company Name] if you do not agree to take all of the terms and conditions stated on this page.</p>" }    
}
